import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, Paper } from '@mui/material';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import { primarySoft } from '../../../../theme';

interface SmsOfferCodeDialogProps {
  open: boolean;
  onClose: () => void;
  offerCodes: string[];
  offerTitles?: string[];
  onSelect: (token: string) => void;
}

function SmsOfferCodeDialog({ open, onClose, offerCodes, offerTitles, onSelect }: SmsOfferCodeDialogProps) {
  const iconSx = { color: 'primary.main', fontSize: '1.1rem', flexShrink: 0 };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ConfirmationNumberIcon sx={{ color: 'primary.main', fontSize: '1.2rem' }} />
          <Typography variant="subtitle1" fontWeight={700}>
            Numéro d&apos;opération
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
          Sélectionnez l&apos;offre dont vous souhaitez insérer le code dans le message.
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {offerCodes.map((token, idx) => {
            const isNew = idx === offerCodes.length - 1;
            return (
              <Paper
                key={token}
                variant="outlined"
                onClick={() => onSelect(token)}
                sx={{
                  p: 1.5,
                  cursor: 'pointer',
                  borderRadius: 2,
                  borderColor: isNew ? 'primary.main' : 'divider',
                  borderStyle: isNew ? 'dashed' : 'solid',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  transition: 'all 0.15s',
                  '&:hover': { borderColor: 'primary.main', backgroundColor: theme => primarySoft(theme, 0.03) },
                }}
              >
                {isNew ? <AddCircleOutlineIcon sx={iconSx} /> : <CardGiftcardIcon sx={iconSx} />}
                <Box>
                  <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.2, color: isNew ? 'primary.main' : 'inherit' }}>
                    {isNew ? `+ Nouvelle offre (Offre ${idx + 1})` : (offerTitles?.[idx] || `Offre ${idx + 1}`)}
                  </Typography>
                  <Typography variant="caption" sx={{ fontFamily: theme => theme.typography.fontFamilyMono, color: 'text.secondary' }}>
                    {token}
                  </Typography>
                </Box>
              </Paper>
            );
          })}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={onClose} sx={{ textTransform: 'none', color: 'text.secondary' }}>
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SmsOfferCodeDialog;
